<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header-class="redmfu">
            <div slot="header">
              <strong v-if="thai_student==1">แบบสอบถามภาวะการมีงานทำของบัณฑิต</strong>
              <strong v-else>Graduate Employability Survey </strong>
            </div>
            <b-row>
              <b-col sm="8">
                <b-form-group
                  :label-cols="3"
                  v-if="thai_student ==1 "
                  label="รหัสประจำตัวนักศึกษา"
                >{{ studentCode }}
                </b-form-group>

                <b-form-group
                  v-if="thai_student ==0 "
                  label="Student ID No."
                  :label-cols="3"

                >{{ studentCode }}
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group
                  v-if="thai_student ==1"
                  label="ชื่อ-นามสกุล"
                  label-for="basicStatic"
                  :label-cols="4"

                >
                  <b-form-group
                    :label="name"
                    label-for="basicStatic"
                    :label-cols="12"

                  ></b-form-group>
                </b-form-group>

                <b-form-group
                  v-if="thai_student ==0 "
                  label="Name and Surname"
                  label-for="basicStatic"
                  :label-cols="4"

                >
                  <b-form-group
                    :label="name"
                    label-for="basicStatic"
                    :label-cols="12"

                  ></b-form-group>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group
                  label="ระดับ"
                  :label-cols="3"

                  v-if="thai_student ==1 "
                >
                  <b-form-group
                    :label="levelGroupName"
                    label-for="basicStatic"
                    :label-cols="6"

                  ></b-form-group>
                </b-form-group>
                <b-form-group
                  label="Level"
                  :label-cols="3"

                  v-if="thai_student ==0 "
                >
                  <b-form-group
                    :label="levelGroupNameEng"
                    label-for="basicStatic"

                    :label-cols="6"
                  ></b-form-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group
                  v-if="thai_student ==1 "
                  label="สำนักวิชา"
                  :label-cols="4"

                >
                  <b-form-group
                    :label="facultyName"
                    label-for="basicStatic"
                    :label-cols="6"

                  ></b-form-group>
                </b-form-group>

                <b-form-group
                  v-if="thai_student ==0 "
                  label="School"
                  :label-cols="4"

                >
                  <b-form-group
                    :label="facultyNameEng"
                    label-for="basicStatic"
                    :label-cols="4"

                  ></b-form-group>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <div v-if="thai_student ==1 ">
                  <b-form-group label="สาขาวิชา" :label-cols="3">
                    <b-form-group
                      :label="departmentName"
                      label-for="basicStatic"
                      :label-cols="12"
                    ></b-form-group>
                  </b-form-group>
                </div>
                <div v-if="thai_student ==0 ">
                  <b-form-group label="Programme" :label-cols="3">
                    <b-form-group
                      :label="departmentNameEng"
                      label-for="basicStatic"
                      :label-cols="12"

                    ></b-form-group>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
<!--            &#45;&#45;{{current_postpone}}-->
            <b-row align="center" v-if="current_postpone==1">

              <b-col>
                <b-button class="m-1" :variant="process_color3">{{lbl_no3}}</b-button>
                <font size="-2"><br>{{ lbl_3 }}</font>
              </b-col>
              <b-col v-if="student2.GRADUATE_STATUS ==50 || student2.GRADUATE_STATUS ==60">
                <i class="cui-arrow-right icons font-2xl d-block mt-4"></i>
              </b-col>
              <b-col v-if="student2.GRADUATE_STATUS ==50 || student2.GRADUATE_STATUS ==60">
                <b-button class="m-1" :variant="process_color4">{{lbl_no4}}</b-button>
                <font size="-2"><br>{{ lbl_4 }}</font>
              </b-col>
              <b-col
                v-if="(student2.GRADUATE_STATUS ==50 || student2.GRADUATE_STATUS ==60)&& (student2.POST_STATUS==21 || student2.POST_STATUS==22 || student2.POST_STATUS==31)">
                <i class="cui-arrow-right icons font-2xl d-block mt-4"></i>
              </b-col>
              <b-col
                v-if="(student2.GRADUATE_STATUS ==50 || student2.GRADUATE_STATUS ==60)&& (student2.POST_STATUS==21 || student2.POST_STATUS==22 || student2.POST_STATUS==31)">
                <b-button class="m-1" :variant="process_color5">{{lbl_no5}}</b-button>
                <font size="-2"><br>{{ lbl_5 }}</font>
              </b-col>

            </b-row>


            <b-row align="center" v-else>
              <b-col>
                <b-button class="m-1" :variant="process_color1">{{lbl_no1}}</b-button>
                <font size="-2"><br>{{ lbl_1 }}</font>
              </b-col>
              <b-col>
                <i class="cui-arrow-right icons font-2xl d-block mt-4"></i>
              </b-col>
              <b-col>
                <b-button class="m-1" :variant="process_color2">{{lbl_no2}}</b-button>
                <font size="-2"><br>{{ lbl_2 }}</font>
              </b-col>
              <b-col>
                <i class="cui-arrow-right icons font-2xl d-block mt-4"></i>
              </b-col>
              <b-col>
                <b-button class="m-1" :variant="process_color3">{{lbl_no3}}</b-button>
                <font size="-2"><br>{{ lbl_3 }}</font>
              </b-col>
              <b-col v-if="student2.GRADUATE_STATUS ==50 || student2.GRADUATE_STATUS ==60">
                <i class="cui-arrow-right icons font-2xl d-block mt-4"></i>
              </b-col>
              <b-col v-if="student2.GRADUATE_STATUS ==50 || student2.GRADUATE_STATUS ==60">
                <b-button class="m-1" :variant="process_color4">{{lbl_no4}}</b-button>
                <font size="-2"><br>{{ lbl_4 }}</font>
              </b-col>
              <b-col
                v-if="(student2.GRADUATE_STATUS ==50 || student2.GRADUATE_STATUS ==60)&& (student2.POST_STATUS==21 || student2.POST_STATUS==22 || student2.POST_STATUS==31)">
                <i class="cui-arrow-right icons font-2xl d-block mt-4"></i>
              </b-col>
              <b-col
                v-if="(student2.GRADUATE_STATUS ==50 || student2.GRADUATE_STATUS ==60)&& (student2.POST_STATUS==21 || student2.POST_STATUS==22 || student2.POST_STATUS==31)">
                <b-button class="m-1" :variant="process_color5">{{lbl_no5}}</b-button>
                <font size="-2"><br>{{ lbl_5 }}</font>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: {YimoVueEditor},
  name: "CreateBio",
  data() {
    return {
      // student: {},
      student2: {},
      std_id: "",
      current_postpone:"",
      numEror: 0,
      name: "",
      thai_student: "",
      studentCode: "",
      prefixName: "",
      studentName: "",
      studentSurname: "",
      studentNameEng: "",
      studentSurnameEng: "",
      prefixNameEng: "",
      levelGroupName: "",
      levelGroupNameEng: "",
      facultyName: "",
      facultyNameEng: "",
      departmentName: "",
      departmentNameEng: "",
      lbl_no1: "",
      lbl_no2: "",
      lbl_no3: "",
      lbl_no4: "",
      lbl_no5: "",
      lbl_1: "",
      lbl_2: "",
      lbl_3: "",
      lbl_4: "",
      lbl_5: "",
      process_color1: "warning",
      process_color2: "warning",
      process_color3: "warning",
      process_color4: "warning",
      process_color5: "warning",
    };
  },
  methods: {
    getPostPay(student) {
      api
        .getStudentPostById(student)
        .then(res => {
          // console.log("getPostPay==", res)
          if (res.data.data.length == 1) {
            this.student2.POST_STATUS = res.data.data[0].POST_STATUS;
            this.student2.PAIDAALREADY = res.data.data[0].PAIDAALREADY;
          } else {
            this.student2.POST_STATUS = 0;
            this.student2.PAIDAALREADY = 10
          }
          if (this.student2.POST_STATUS > 0) {
            this.process_color4 = "success";
          } else {
            this.process_color4 = "warning";
          }
          if (this.student2.PAIDAALREADY == 1) {
            this.process_color5 = "success";
          } else {
            this.process_color5 = "warning";
          }
        })
        .catch(err => {
          console.log("getStudentPostPay", err.toString());
        });
    },
    getProcessColor(student) {
      // console.log("getProcessColor==", student,student.QUESTIONNAIRE_1);
      if (student.QUESTIONNAIRE_1 == "1") {
        this.process_color1 = "success";
      } else {
        this.process_color1 = "warning";
      }
      if (student.QUESTIONNAIRE_7 == 1) {
        this.process_color2 = "success";
      } else {
        this.process_color2 = "warning";
      }
      if (student.GRADUATE_STATUS == 10 || student.GRADUATE_STATUS == 20 || student.GRADUATE_STATUS == 21 || student.GRADUATE_STATUS == 22 || student.GRADUATE_STATUS == 23 || student.GRADUATE_STATUS == 30 || student.GRADUATE_STATUS == 40 || student.GRADUATE_STATUS == 50 || student.GRADUATE_STATUS == 60) {
        this.process_color3 = "success";
      } else {
        this.process_color3 = "warning";
      }

    },
    getGraduateStatus(student) {
      this.numEror = 0;
      api
        .getStudentUserQuestionById(student.studentid)
        .then(res => {
            if (res.data.data.length == 1) {
              this.student2.GRADUATE_STATUS = res.data.data[0].GRADUATE_STATUS;
              this.student2.QUESTIONNAIRE_1 = res.data.data[0].QUESTIONNAIRE_1;
              this.student2.QUESTIONNAIRE_7 = res.data.data[0].QUESTIONNAIRE_7;
              if (this.student2.GRADUATE_STATUS == 50 || this.student2.GRADUATE_STATUS == 60 || this.student2.GRADUATE_STATUS == 70) {
                this.getPostPay(student);
              } else {
                this.student2.POSTSTATUS = 10;
                this.student2.PAIDAALREADY = 10
              }
              // console.log("student2==", this.student2);
              this.getProcessColor(this.student2)
            } else {
              this.student2.GRADUATE_STATUS = 0;
              this.student2.QUESTIONNAIRE_1 = 0;
              this.student2.QUESTIONNAIRE_7 = 0;
              this.student2.POSTSTATUS = 10;
              this.student2.PAIDAALREADY = 10;
            }
          }
        )
        .catch(err => {
          console.log("getStatus==", err.toString());
        });
    },
    getStudentBio() {
      this.sex = this.$store.state.user.sex;
      this.thai_student = this.$store.state.user.thaistudent;
      this.studentId = this.$store.state.user.studentid;
      this.std_id = this.$store.state.user.studentid;
      this.studentCode = this.$store.state.user.studentcode;
      this.prefixName = this.$store.state.user.prefixname;
      this.studentName = this.$store.state.user.studentname;
      this.studentSurname = this.$store.state.user.studentsurname;
      var student = {}
      student.studentid = this.std_id
      student.thaistudent = this.thai_student
      student.year = this.$store.state.user.year;
      this.getGraduateStatus(student)

      if (this.studentSurname == null) {
        this.studentSurname = "";
      }
      this.name =
        this.prefixName +
        "   " +
        this.studentName +
        "   " +
        this.studentSurname;
      this.prefixNameEng = this.$store.state.user.prefixnameeng;
      this.studentNameEng = this.$store.state.user.studentnameeng;
      this.studentSurnameEng = this.$store.state.user.studentsurnameeng;
      this.levelGroupName = this.$store.state.user.levelgroupname;
      this.levelGroupNameEng = this.$store.state.user.levelgroupnameeng;
      this.departmentName = this.$store.state.user.departmentname;
      this.departmentNameEng = this.$store.state.user.departmentnameeng;
      this.facultyName = this.$store.state.user.facltyname;
      this.facultyNameEng = this.$store.state.user.facltynameeng;
      this.levelid = this.$store.state.user.levelid;
      this.current_postpone=this.$store.state.user.postpone_status;
      // console.log("user==", this.$store.state.user);
    }
  },
  mounted() {
  }
  ,
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/Logout");
    } else {
      this.getStudentBio();
      if (this.current_postpone==1) {
        this.lbl_no3 = 1;
        this.lbl_no4 = 2;
        this.lbl_no5 = 3;
        if (this.thai_student == 1) {

          this.lbl_3 = "การแจ้งความประสงค์เข้ารับพระราชทานปริญญาบัตร"
          this.lbl_4 = "ยืนยันการติดต่อขอรับปริญญาบัตร"
          this.lbl_5 = "ชำระเงินค่าจัดส่งทางไปรษณีย์"
        } else {

          this.lbl_3 = "Confirmation to attend the commencement ceremony"
          this.lbl_4 = "The way to obtain Certificate"
          this.lbl_5 = "Payment"
        }
      } else {
        this.lbl_no1 = 1;
        this.lbl_no2 = 2;
        this.lbl_no3 = 3;
        this.lbl_no4 = 4;
        this.lbl_no5 = 5;

        if (this.thai_student == 1) {
          if (this.current_postpone==0) {
            this.lbl_1 = "แบบสอบถามภาวะการมีงานทำของบัณฑิต"
            this.lbl_2 = "แบบประเมินความพึงพอใจของบัณฑิตต่อทักษะ 7 ด้าน"
            this.lbl_3 = "การแจ้งความประสงค์เข้ารับพระราชทานปริญญาบัตร"
            this.lbl_4 = "ยืนยันการติดต่อขอรับปริญญาบัตร"
            this.lbl_5 = "ชำระเงินค่าจัดส่งทางไปรษณีย์"
          }else{
            this.lbl_3 = "การแจ้งความประสงค์เข้ารับพระราชทานปริญญาบัตร"
            this.lbl_4 = "ยืนยันการติดต่อขอรับปริญญาบัตร"
            this.lbl_5 = "ชำระเงินค่าจัดส่งทางไปรษณีย์"
          }
        } else {
          if (this.current_postpone==0) {
            this.lbl_1 = "Employment Survey"
            this.lbl_2 = "The Assessment of Graduates’ Satisfaction with Seven Domains of Learning Outcomes"
            this.lbl_3 = "Confirmation to attend the commencement ceremony"
            this.lbl_4 = "The way to obtain Certificate"
            this.lbl_5 = "Payment"
          }else{
            this.lbl_3 = "Confirmation to attend the commencement ceremony"
            this.lbl_4 = "The way to obtain Certificate"
            this.lbl_5 = "Payment"
          }
        }
      }
    }
  }
}
;
</script>
<style>
.redmfu {
  background-color: #c93632;
  color: white;
}
</style>
